import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'

import { spamContactAction } from '../../../reduxes/slices/contacts/actions'
import { useUnknownContact } from '../use_unknown_contact'
import { UnknownPanel } from './unknown_panel'
import {useAxios} from "../../../hooks/use_axios";

const dialogButtonStyles = css({
  padding: '0 $5',
})

export type UnknownContactPanelProps = {
  showMessages: boolean
  setShowMessages: React.Dispatch<React.SetStateAction<boolean>>
  toggleAction: any
}

export const UnknownContactPanel = ({
  showMessages,
  setShowMessages,
  toggleAction,
}: UnknownContactPanelProps) => {
  const dispatch = useDispatch()
  const axios = useAxios()
  const { name, handle } = useUnknownContact()

  const handleApprove = useCallback(() => {
    dispatch(axios(spamContactAction(handle, 'approve')))
  }, [axios, dispatch, handle])

  const previewMessages = useCallback(() => {
    setShowMessages((prev) => !prev)
  }, [setShowMessages])

  const handleBlock = () => {
    toggleAction('block')
  }

  const handleReport = () => {
    toggleAction('report')
  }

  return (
    <UnknownPanel
      showMessages={showMessages}
      previewMessages={previewMessages}
      handle={handle}
      name={name}
      subheader={`New direct message from ${handle}`}
    >
      <Stack gap="3" direction="row">
        <Button className={dialogButtonStyles()} onClick={handleBlock}>
          Block
        </Button>
        <Button className={dialogButtonStyles()} onClick={handleReport}>
          Report
        </Button>
        <Button
          className={dialogButtonStyles()}
          onClick={handleApprove}
          variant={'primary'}
        >
          OK
        </Button>
      </Stack>
    </UnknownPanel>
  )
}
